export default function () {
  this.getTags()
}



// WEBPACK FOOTER //
// ./src/app/professional/company/companies/components/tags/resources/mounted.js